<script lang="ts">
	import { get } from 'svelte/store';
	import { devices_status } from 'src/stores';
	import { Alert, Button, Text, toast } from '@Shelly/shelly-design-system';
	import { getWaveCoverComponentId, zwaveCoverCalibrate } from 'src/helpers/z_wave_cover_helpers';
	import { real_id } from 'src/helpers/interface_helpers';
	import { getContext, onDestroy } from 'svelte';
	import type { Writable } from 'svelte/store';
	import type { SidepanelStickyBottomProps } from 'src/components/Sidepanel/sidepanel-types';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import { format } from 'svelte-i18n';

	export let device;

	let loading = false;

	const startCalibration = async () => {
		loading = true;
		const componentId = getWaveCoverComponentId(device);
		const coverStatus = get(devices_status)?.[real_id(device.id)]?.[`cover:${componentId}`];
		const state = coverStatus?.state;

		if (state === 'opening' || state === 'closing') {
			toast.open({
				type: 'danger',
				title: $format('cover_before_calibration_error', {
					default: 'Cover is opening/closing. Wait for movement to finish before calibrating.',
				}),
			});
			loading = false;
			return;
		}

		const res = await zwaveCoverCalibrate(device);
		if (res.isok) {
			toast.open({
				type: 'success',
				title: $format('calibration_started_scc_toast'),
			});
		} else {
			toast.open({ type: 'danger', title: $format('error_global') });
		}
		loading = false;
	};

	const stickyBottomAction =
		getContext<Writable<SidepanelStickyBottomProps | null>>('stickyBottomAction');

	$: if (stickyBottomAction) {
		if ($showNewLayout) {
			stickyBottomAction.set({
				onClick: startCalibration,
				loading,
				disabled: loading,
				label: $format('button_start_calibration'),
			});
		} else {
			stickyBottomAction.set(null);
		}
	}

	onDestroy(() => {
		stickyBottomAction?.set(null);
	});
</script>

<Text styleType="body-small" class="mb-s">
	{$format('calib_shutter_description', {
		default: 'Calibration allows your shutter to have position control.',
	})}
</Text>
<Alert
	type="warning"
	isHeadingBold
	heading={$format('alert_warning_local_control_setting', {
		default: 'Attention',
	})}
	message={$format('calib_warn_description', {
		default: 'Please make sure that there are no obstacles in the way during the calibration.',
	})}
/>
{#if !$showNewLayout}
	<Button class="mt-s" {loading} size="m" width="full" on:click={startCalibration}>
		{$format('button_start_calibration')}
	</Button>
{/if}
